import { render } from "./App.vue?vue&type=template&id=426b6f88&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=426b6f88&scoped=true&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b3655c94b52f2edce08bd59b38cc948d/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426b6f88"]])

export default __exports__